import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { styled as materialStyles } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch } from "react-redux";
import { getCommodityGroupsThunk } from "../../commodityGroup/redux/commodityGroupSlice";
import { getMaterialGroupsThunk } from "../../materialGroup/redux/materialGroupSlice";
import { getSubCategoriesThunk } from "../../subCategory/redux/subCategorySlice";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import FormGroup from "@mui/material/FormGroup";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SearchIcon from "@mui/icons-material/Search";
import { FileDownload } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import VRF_vishakha from "../../../assets/F-PUR-03-VRF-Vishakha.DOCX";
import {
  vendorRegistration,
  hsnCategories,
  hsnValues,
  itemValues,
  getMasterItems,
  getVendorTermsAndConditions,
  submitVendorEdit,
  validateMSMENumber,
  getUserDetails,
} from "../redux/vendorRegistrationSlice";
import {
  UserInfoDiv,
  VendorCardTitle,
  VendorInstructions,
  VendorListHolder,
} from "./steps/vendorReg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import styled from "styled-components";
import BankReg from "./steps/bankReg";
import BankDetailsManager from "./steps/BankDetailsManager";
import MsmeComponents from "../../../common/sharedComponents/styles/msmeComponents";
import BankDetailsContent1 from "../../bankDetails/components/bankDetailsContent1";
import VendorDocumentRequests from "../../documentRequests/VendorDocumentRequests";
import { useSelector } from "react-redux";
import { Super, VendorCardBlankTitle } from "./steps/cardTrial";
import FormHelperText from "@mui/material/FormHelperText";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
/* import ArrowRightIcon from "@mui/icons-material/ArrowRight"; */
import _without from "lodash/without";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";
import apiClient from "../../../utilities/apiClient";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Clear } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
// import { bank_info } from "../../../utilities/helper";
import { CustomDocumentLink } from "../../../common/sharedComponents/styles/card.style";
import { useFeature } from "../../../common/featureFlags/FeatureProvider";

const Input = materialStyles("input")({
  display: "none",
});

export const concernTypeForJaslok = [
  { concernTypeId: 7, concernType: "Artificial Juridical Person" },
  { concernTypeId: 4, concernType: "Association of Person" },
  { concernTypeId: 8, concernType: "Body of Individuals" },
  { concernTypeId: 9, concernType: "Central Government" },
  { concernTypeId: 3, concernType: "Company" },
  { concernTypeId: 6, concernType: "Hindu Undivided Family" },
  { concernTypeId: 1, concernType: "Partnership Firm" },
  { concernTypeId: 2, concernType: "Proprietor" },
  { concernTypeId: 10, concernType: "State Government" },
  { concernTypeId: 5, concernType: "Trust" },
];

export default function StepMain() {
  var user = LocalStorage.getItem(SESSION_KEY);
  const navigate = useNavigate();
  const [finalSubmitLoading, setFinalSubmitLoading] = useState(false);
  const is_domestic = user?.is_domestic;
  const showRequestedDocs = useFeature("requested_documents");
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const isVendorTerms = useFeature("show_vendor_terms");
  const isLinkCategory = useFeature("link_vendor_category_on_register");
  const showCommodityGroups = useFeature("show_commodity_groups");
  const showMaterialGroups = useFeature("show_material_groups");
  const showSubCategories = useFeature("show_sub_categories");
  const showWebsite = useFeature("show_website");
  const showYearOfEstablishment = useFeature("show_year_of_establishment");
  const showCinValidation = useFeature("cin_registration");
  const showIecRegistration = useFeature("iec_registration");
  const showFactoryRegistration = useFeature("factory_license_registration");
  const showEprRegistration = useFeature("epr_registration");
  const showPollutionRegistration = useFeature(
    "pollution_control_registration",
  );
  const showMajorCustomerList = useFeature("show_major_customer_list");
  const showAffirmativeAction = useFeature("show_affirmative_action");
  const showRegInfoCard =
    showCinValidation ||
    showIecRegistration ||
    showFactoryRegistration ||
    showEprRegistration ||
    showPollutionRegistration;
  const steps = [
    "Vendor Details",
    "Business Details",
    "Bank Details",
    "Documents",
    "Finish",
  ];

  const value = LocalStorage.getItem(SESSION_KEY);
  const vendorCompany = LocalStorage.getItem("client");
  const {
    categories,
    subcategories,
    itemcategories,
    Items,
    vendorTermsAndConditions,
    createdUser,
    msmeLoading,
  } = useSelector((state) => state.vendorRegistration);
  const [anyDocs, setAnyDocs] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [checkedPan, setCheckedPan] = useState(false);
  const [panDoc, setPanDoc] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [msmeDoc, setmsmeDoc] = useState("");
  const [dealer, setDealer] = useState("");
  const [tin, setTin] = useState("");
  const [iso, setIso] = useState("");
  const [coa, setCoa] = useState("");
  const [qualityAudit, setQualityAudit] = useState("");
  const [hazardous, setHazardous] = useState("");
  const [sds, setSds] = useState("");
  const [unCert, setUnCert] = useState("");
  const [vendorSite, setVendorSite] = useState("");
  const [cinDoc, setCinDoc] = useState("");
  const [cinError, setCinError] = useState("");
  const [iecDoc, setIecDoc] = useState("");
  const [iecError, setIecError] = useState("");
  const [factoryDoc, setFactoryDoc] = useState("");
  const [factoryError, setFactoryError] = useState("");
  const [eprDoc, setEprDoc] = useState("");
  const [eprError, setEprError] = useState("");
  const [pollutionDoc, setPollutionDoc] = useState("");
  const [pollutionError, setPollutionError] = useState("");
  const [checkedType, setCheckedType] = useState("");
  // const [checkedItemType, setCheckedItemType] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [mSME, setMSME] = useState("");
  const [checkedMSME, setCheckedMSME] = useState(false);
  const [validatedMsmeData, setValidatedMsmeData] = useState(null);

  const [userinfo, setUserInfo] = useState({
    codes: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingsub, setIsLoadingsub] = useState(false);
  const [search, setSearch] = useState("");
  const [searchsub, setSearchsub] = useState("");
  const [catdisplay, setCatdisplay] = useState("none");
  const [subcatdisplay, setSubcatdisplay] = useState("none");

  const [itemcodes, setItemcodes] = useState("");
  const [isLoadingitem, setIsLoadingitem] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [itemcatdisplay, setItemcatdisplay] = useState("none");
  // const [masterItemcodes, setMasterItemcodes] = useState("");
  const [isLoadingMasteritem, setIsLoadingMasteritem] = useState(false);
  const [mastercatdisplay, setMastercatdisplay] = useState("none");
  const [searchMasteritem, setSearchMasteritem] = useState("");
  // const [itemcatdisplay, setItemcatdisplay] = useState("none");
  const [loading, setLoading] = useState(false);
  const [
    is_accept_vendor_terms_conditions,
    set_is_accept_vendor_terms_conditions,
  ] = useState(false);

  const dispatch = useDispatch();
  const { commodityGroupList } = useSelector((state) => state.commodityGroup);
  const { materialGroupList } = useSelector((state) => state.materialGroup);
  const { subCategoryList } = useSelector((state) => state.subCategory);
  const handleFinalSubmit = () => {
    setFinalSubmitLoading(true);
    const currentVendorId =
      createdUser?.vendor_id || value?.vendor_id || value?.id;
    const payload = {
      vendor_id: currentVendorId,
      is_finish: true,
    };
    dispatch(submitVendorEdit(payload))
      .unwrap()
      .then((res) => {
        setFinalSubmitLoading(false);
        if (res?.success) {
          message.success("Registration completed successfully!");
          navigate("/app");
        } else {
          message.info(res?.message || "No pending edits to submit.");
          navigate("/app");
        }
      })
      .catch((err) => {
        setFinalSubmitLoading(false);
        message.error("Failed to finalize registration.");
      });
  };
  const onSubmit = (payload) => {
    setLoading(true);
    dispatch(vendorRegistration(payload)).then((response) => {
      if (response?.payload?.success && !response?.payload?.errorMessage) {
        setLoading(false);
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      } else {
        setLoading(false);
        const errorMsg =
          response?.payload?.errorMessage ||
          response?.payload?.message ||
          response?.payload?.error ||
          response?.error?.message ||
          "Failed to save vendor registration";
        message.error(errorMsg);
      }
    });
  };

  useEffect(() => {
    if (value?.user_id) {
      dispatch(getUserDetails(value.user_id))
        .then((res) => {
          const response = res?.payload?.data || res?.payload || res?.data;
          if (response && response.permanent_account_number) {
            setPanNumber(response.permanent_account_number);
          }
        })
        .catch((err) => {
          console.error("Error fetching PAN number:", err);
        });
    }
  }, [value?.user_id, dispatch]);

  useEffect(() => {
    if (showCommodityGroups) {
      dispatch(getCommodityGroupsThunk({ page: 1, per_page: 10000 }));
    }
    if (showMaterialGroups) {
      dispatch(getMaterialGroupsThunk({ page: 1, per_page: 10000 }));
    }
    if (showSubCategories) {
      dispatch(getSubCategoriesThunk({ page: 1, per_page: 10000 }));
    }
  }, [dispatch, showCommodityGroups, showMaterialGroups, showSubCategories]);

  const handlechangeDoc = (e, index) => {
    let newDocValues = { ...anyDocs, [index]: e.target.files[0] };

    setAnyDocs(newDocValues);
  };

  const handleclearDoc = (e, index) => {
    let newDocValues = { ...anyDocs, [index]: "" };

    setAnyDocs(newDocValues);
  };
  const getCategories = (payload) => {
    dispatch(hsnCategories(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoading(false);
      }
    });
  };

  const getItems = (payload) => {
    dispatch(getMasterItems(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingMasteritem(false);
      }
    });
  };

  const getHSNCodes = (payload) => {
    dispatch(hsnValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingsub(false);
      }
    });
  };

  const getItemsCodes = (payload) => {
    dispatch(itemValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingitem(false);
      }
    });
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
  } = useForm({
    defaultValues: {
      cin_applicable: "Not Applicable",
      iec_applicable: "Not Applicable",
      factory_license_applicable: "Not Applicable",
      epr_applicable: "Not Applicable",
      pollution_control_applicable: "Not Applicable",
    },
  });

  const watchedConstitution = watch("company_constitution");
  const watchedCinApplicable = watch("cin_applicable");
  const watchedIecApplicable = watch("iec_applicable");
  const watchedFactoryApplicable = watch("factory_license_applicable");
  const watchedEprApplicable = watch("epr_applicable");
  const watchedPollutionApplicable = watch("pollution_control_applicable");

  const watchedIecNumber = watch("iec_number");
  const watchedFactoryNumber = watch("factory_license_number");
  const watchedEprNumber = watch("epr_number");
  const watchedPollutionNumber = watch("pollution_control_number");

  const isCinForced =
    showCinValidation &&
    is_domestic === true &&
    (watchedConstitution === "Private Limited Company" ||
      watchedConstitution === "Private Limited" ||
      watchedConstitution === "Limited Liability Partnership (LLP)");

  const resolvedCinApplicable = isCinForced
    ? "Applicable"
    : watchedCinApplicable || "Not Applicable";

  useEffect(() => {
    if (showCinValidation) {
      if (isCinForced) {
        setValue("cin_applicable", "Applicable");
      } else {
        setValue("cin_applicable", "Not Applicable");
      }
    }
  }, [watchedConstitution, isCinForced, setValue, showCinValidation]);
  const [newDocs, setNewDocs] = useState([1]);
  const handleOnClick = () => {
    let docsCopy = [...newDocs];

    docsCopy.push({
      any_docs: "",
    });

    setNewDocs(docsCopy);
  };

  const handleRemove = (e, i) => {
    let uploadeddocs = [...newDocs];
    uploadeddocs.splice(i, 1);
    setNewDocs(uploadeddocs);
  };
  const handleNext = (data) => {
    if (
      activeStep === 0 &&
      is_domestic &&
      mSME === "Applicable" &&
      !checkedMSME
    ) {
      return message.error(
        "Please validate your MSME registration number before proceeding.",
      );
    }
    let hasError = false;

    if (showCinValidation) {
      if (resolvedCinApplicable === "Applicable") {
        if (!data.cin_number) {
          setError("cin_number", {
            type: "manual",
            message: "CIN Number is required",
          });
          hasError = true;
        }
        if (!cinDoc) {
          setCinError("CIN document copy is required");
          hasError = true;
        } else {
          setCinError("");
        }
      } else {
        setCinError("");
      }
    }

    if (showIecRegistration) {
      if (watchedIecApplicable === "Applicable") {
        if (!data.iec_number) {
          setError("iec_number", {
            type: "manual",
            message: "Import Export Code is required",
          });
          hasError = true;
        }
        if (!iecDoc) {
          setIecError("IEC document copy is required");
          hasError = true;
        } else {
          setIecError("");
        }
      } else {
        setIecError("");
      }
    }

    if (showFactoryRegistration) {
      if (watchedFactoryApplicable === "Applicable") {
        if (!data.factory_license_number) {
          setError("factory_license_number", {
            type: "manual",
            message: "Factory License Number is required",
          });
          hasError = true;
        }
        if (!factoryDoc) {
          setFactoryError("Factory license document copy is required");
          hasError = true;
        } else {
          setFactoryError("");
        }
      } else {
        setFactoryError("");
      }
    }

    if (showEprRegistration) {
      if (watchedEprApplicable === "Applicable") {
        if (!data.epr_number) {
          setError("epr_number", {
            type: "manual",
            message: "EPR Number is required",
          });
          hasError = true;
        }
        if (!eprDoc) {
          setEprError("EPR certificate upload is required");
          hasError = true;
        } else {
          setEprError("");
        }
        if (!data.epr_expiry) {
          setError("epr_expiry", {
            type: "manual",
            message: "EPR certificate expiry is required",
          });
          hasError = true;
        }
      } else {
        setEprError("");
      }
    }

    if (showPollutionRegistration) {
      if (watchedPollutionApplicable === "Applicable") {
        if (!data.pollution_control_number) {
          setError("pollution_control_number", {
            type: "manual",
            message: "Pollution Control Certificate Number is required",
          });
          hasError = true;
        }
        if (!pollutionDoc) {
          setPollutionError("Pollution control certificate upload is required");
          hasError = true;
        } else {
          setPollutionError("");
        }
        if (!data.pollution_control_expiry) {
          setError("pollution_control_expiry", {
            type: "manual",
            message: "Pollution control certificate expiry is required",
          });
          hasError = true;
        }
      } else {
        setPollutionError("");
      }
    }

    if (hasError) return;

    var formData = new FormData();

    const resolvedData = {
      ...data,
      cin_applicable: showCinValidation
        ? resolvedCinApplicable
        : "Not Applicable",
      iec_applicable: showIecRegistration
        ? watchedIecApplicable || "Not Applicable"
        : "Not Applicable",
      factory_license_applicable: showFactoryRegistration
        ? watchedFactoryApplicable || "Not Applicable"
        : "Not Applicable",
      epr_applicable: showEprRegistration
        ? watchedEprApplicable || "Not Applicable"
        : "Not Applicable",
      pollution_control_applicable: showPollutionRegistration
        ? watchedPollutionApplicable || "Not Applicable"
        : "Not Applicable",
      major_customers: majorCustomers.filter((name) => name.trim() !== ""),
    };

    if (validatedMsmeData) {
      resolvedData.msme_type = validatedMsmeData.msme_type;
      resolvedData.classification_date = validatedMsmeData.classification_date;
      resolvedData.classification_year = validatedMsmeData.classification_year;
      resolvedData.enterprise_activity = validatedMsmeData.enterprise_activity;
      resolvedData.enterprise_name = validatedMsmeData.enterprise_name;
      resolvedData.msme_registration_number =
        validatedMsmeData.msme_registration_number;
    }

    formData.append("data", JSON.stringify(resolvedData));
    formData.append("msme_certificate_image", msmeDoc);

    if (showCinValidation && cinDoc)
      formData.append("cin_document_image", cinDoc);
    if (showIecRegistration && iecDoc)
      formData.append("iec_document_image", iecDoc);
    if (showFactoryRegistration && factoryDoc)
      formData.append("factory_license_document_image", factoryDoc);
    if (showEprRegistration && eprDoc)
      formData.append("epr_document_image", eprDoc);
    if (showPollutionRegistration && pollutionDoc)
      formData.append("pollution_control_document_image", pollutionDoc);

    formData.append("codes", JSON.stringify(userinfo.codes));
    formData.append("pan_declaration", checkedPan);
    formData.append(
      "is_accept_vendor_terms_conditions",
      is_accept_vendor_terms_conditions,
    );
    formData.append("vendor_terms_id", vendorTermsAndConditions?.id);

    onSubmit(formData);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCheckedPan(false);
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      setCheckedPan(true);
    } else {
      setCheckedPan(false);
    }
  };

  const handleadditionalChange = (e, type) => {
    setCheckedType(type);

    type === "3" ? getItems("") : getCategories(type === "2" ? "HSN" : "SAC");
    type === "3" ? setIsLoadingMasteritem(true) : setIsLoading(true);
    if (Number(type) === "3") {
      setMastercatdisplay("block");
    } else {
      setCatdisplay("block");
    }
    type === "3" ? setSearchMasteritem("") : setSearch("");

    setItemcatdisplay("none");
    setSubcatdisplay("none");
  };

  // const handleadditionalItem = (e) => {
  //   setIsLoading(true);
  //   setSearchMasteritem("");
  //   setMasterItemcodes("block");
  // };
  const initialSelected = [];
  const [personName, setPersonName] = useState(initialSelected);
  const [registrationtype, setRegistrationtype] = useState("");
  const [msmenum, setMsmenum] = useState("");
  const [annualCr, setAnnualCr] = useState("₹0.00 CR");
  const [majorCustomers, setMajorCustomers] = useState([""]);

  const handleAddCustomer = () => {
    setMajorCustomers([...majorCustomers, ""]);
  };

  const handleRemoveCustomer = (index) => {
    const list = [...majorCustomers];
    list.splice(index, 1);
    setMajorCustomers(list.length > 0 ? list : [""]);
  };

  const handleCustomerChange = (index, value) => {
    const list = [...majorCustomers];
    list[index] = value;
    setMajorCustomers(list);
  };

  const handlecategoryChange = (e, type) => {
    setSubCategory(type);
    getHSNCodes(type);
    setIsLoadingsub(true);
    setSearchsub("");
    setSubcatdisplay("block");
    setItemcatdisplay("none");
  };

  const handlesubcategoryChange = (e, type) => {
    setItemcodes(type);
    getItemsCodes(type);
    setIsLoadingitem(true);
    setSearchitem("");
    setItemcatdisplay("block");
  };

  const handleDelete = (chipToDelete) => () => {
    let codes = userinfo.codes;

    let filtered = codes.filter((codes) =>
      codes.toLowerCase().includes(chipToDelete.toLowerCase()),
    );
    const array1 = codes.filter((val) => !filtered.includes(val));
    setUserInfo({
      codes: array1,
    });
    setPersonName((current) => _without(current, chipToDelete));
    // setUserInfo({})
  };

  const handleCheckChange = (e, type) => {
    const { checked } = e.target;
    const { codes } = userinfo;
    if (checked) {
      setUserInfo({
        codes: [...codes, type],
      });
      setPersonName([...personName, type]);
    }
  };

  const handlemsme = (value) => {
    setMSME(value);
    setMsmenum("");
    setCheckedMSME(false);
    setValidatedMsmeData(null);
    setValue("msme_register", value, { shouldValidate: true });
  };

  const validateMsme = () => {
    if (!watch("company_constitution")) {
      return message.error("Please select Company constitution first");
    }
    if (!msmenum) {
      return message.info("Please enter MSME Registration Number");
    }
    dispatch(
      validateMSMENumber({
        msme: msmenum,
        company_constitution: watch("company_constitution"),
        legal_name: value?.legal_name || watch("legal_name") || "",
        user_id: value?.user_id || createdUser?.id || undefined,
      }),
    ).then((response) => {
      const { success, data } = response.payload;
      if (
        success &&
        data?.[0]?.status === "completed" &&
        data?.[0]?.result?.source_output?.status === "id_found"
      ) {
        setCheckedMSME(true);
        const generalDetails = data[0]?.result?.source_output?.general_details;
        const enterpriseTypeData =
          data[0]?.result?.source_output?.enterprise_type?.[0]
            ?.enterprise_type_1;
        setValidatedMsmeData({
          msme_registration_number: msmenum || "",
          msme_type: generalDetails?.enterprise_type || "",
          enterprise_name: generalDetails?.enterprise_name || "",
          enterprise_activity: generalDetails?.major_activity || "",
          classification_date: enterpriseTypeData?.classification_date || "",
          classification_year: enterpriseTypeData?.classification_year || "",
        });
      } else {
        setCheckedMSME(false);
        setValidatedMsmeData(null);
      }
    });
  };
  // const handleMsmeReg = (e) => {
  //   setMsmenum(e.target.value);
  // };

  const handleregistrationChange = (e) => {
    setRegistrationtype(e.target.value);
  };

  const code_filtered = !search
    ? categories
    : categories.filter((categories) =>
        categories.categortDescription
          .toLowerCase()
          .includes(search.toLowerCase()),
      );

  const sub_filtered = !searchsub
    ? subcategories
    : subcategories.filter((subcategories) =>
        subcategories.subCategory
          .toLowerCase()
          .includes(searchsub.toLowerCase()),
      );

  const item_filtered = !searchitem
    ? itemcategories
    : itemcategories.filter((itemcategories) =>
        itemcategories.item.toLowerCase().includes(searchitem.toLowerCase()),
      );
  const master_item_filtered = !searchMasteritem
    ? Items
    : Items.filter((items) =>
        items.MaterialCode.toLowerCase().includes(
          searchMasteritem.toLowerCase(),
        ),
      );

  const radioStyles = {
    selectRadio: {
      border: "1px solid #D9D8FF",
      padding: "0px 7px 0px 7px",
      background: "#D9D8FF",
      borderRadius: "4px",
      marginLeft: "-6px",
    },
  };

  const radioStyles1 = {
    selectRadio: {
      border: "1px solid #D9D8FF",
      padding: "0px 7px 0px 7px",
      background: "#D9D8FF",
      borderRadius: "4px",
      marginLeft: "-6px",
      marginRight: "15px",
    },
  };

  // Function to convert to millions and format as currency
  const convertToMillions = (e) => {
    const num = e.target.value;
    if (num === undefined) return "";
    const millions = num / 10;

    const ready =
      millions.toLocaleString("en-IN", { style: "currency", currency: "INR" }) +
      " CR";
    setAnnualCr(ready);
  };

  const card = (
    <CardContent>
      {/* {is_domestic} */}
      <Typography gutterBottom variant="h6" component="div">
        <VendorInstructions>
          <InfoIcon color="primary" /> {"\u00A0"}
          {"\u00A0"}Instructions
        </VendorInstructions>
      </Typography>
      <br />

      <VendorListHolder>
        <li>
          Enter statutory information which includes company nature,
          constitution and GST registration type.
        </li>
        <li>
          Legal name is auto-populated as per the information on the PAN
          database. It is not editable for vendors.
        </li>
        <li>
          Enter all the mandatory fields before proceeding to enter location
          information.
        </li>
        <li className="text-danger">Documents size cannot exceed 500kb</li>
      </VendorListHolder>
    </CardContent>
  );

  const statutory_information = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Statutory information</VendorCardTitle>
          <UserInfoDiv>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company name</VendorCardLabel>
                <VendorDisabledFields>
                  {value.company_name}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company email</VendorCardLabel>

                <VendorDisabledFields>
                  {value.contact_person_email}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} md={4}>
                <VendorCardLabel>
                  Permanent account number (PAN)
                </VendorCardLabel>

                <VendorDisabledFields>
                  {panNumber ? `${panNumber}` : `International`}
                </VendorDisabledFields>
              </Grid>
            </Grid>
          </UserInfoDiv>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>
              Legal name <Super>*</Super>
            </VendorCardLabel>

            <VendorDisabledFields
              style={{
                borderBottom: "1px solid lightgray",
                width: "100%",
                padding: " 0 0 5px 0",
                paddingTop: "5px",
              }}
            >
              {typeof value.legal_name !== undefined &&
              value.legal_name !== null
                ? `${value.legal_name}`
                : `Not Applicable`}
            </VendorDisabledFields>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_constitution)}
            >
              <VendorCardLabel>
                Company constitution <Super>*</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_constitution"
                label="Company consistution (As per GST certificate)"
                name="company_constitution"
                {...register("company_constitution", {
                  required: "Please select constitution",
                })}
                onChange={(e) => {
                  setValue("company_constitution", e.target.value, {
                    shouldValidate: true,
                  });
                  setCheckedMSME(false);
                  setValidatedMsmeData(null);
                }}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select constitution
                  </span>
                </MenuItem>

                <MenuItem value="Association of Persons (AOP)">
                  <SelectSpan>Association of Persons (AOP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Partnership Firm">
                  <SelectSpan>Partnership Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Individual/One person Company">
                  <SelectSpan>Individual/One person Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Individual">
                  <SelectSpan>Individual</SelectSpan>
                </MenuItem>
                <MenuItem value="Joint Venture (JV)">
                  <SelectSpan>Joint Venture (JV)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Liability Partnership (LLP)">
                  <SelectSpan>Limited Liability Partnership (LLP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited">
                  <SelectSpan>Limited</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Company/Listed company">
                  <SelectSpan>Limited Company/Listed company</SelectSpan>
                </MenuItem>
                <MenuItem value="Non banking finance company/ Banking company">
                  <SelectSpan>
                    Non banking finance company/ Banking company
                  </SelectSpan>
                </MenuItem>
                <MenuItem value="Proprietary Firm">
                  <SelectSpan>Proprietary Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Private Limited Company">
                  <SelectSpan>Private Limited Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Firm">
                  <SelectSpan>Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Private Limited">
                  <SelectSpan>Private Limited</SelectSpan>
                </MenuItem>
                <MenuItem value="Co-operative society">
                  <SelectSpan>Co-operative society</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Hindu Undivided Family">
                  <SelectSpan>Hindu Undivided Family</SelectSpan>
                </MenuItem>
                <MenuItem value="Government Organisation">
                  <SelectSpan>Government Organisation</SelectSpan>
                </MenuItem>
                <MenuItem value="Government Company">
                  <SelectSpan>Government Company</SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.company_constitution?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_nature)}
            >
              <VendorCardLabel>
                Company nature<Super> *</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_nature"
                label="company_nature"
                name="company_nature"
                {...register("company_nature", {
                  required: "Please select company nature",
                })}
                error={Boolean(errors?.company_nature)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select company nature
                  </span>
                </MenuItem>

                <MenuItem value="dta">
                  <SelectSpan>Domestic Tariff Area (DTA)</SelectSpan>
                </MenuItem>
                <MenuItem value="domestic">
                  <SelectSpan> Indian Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company (Outside India)</SelectSpan>
                </MenuItem>
                <MenuItem value="sez">
                  <SelectSpan>Special Economic Zone (SEZ)</SelectSpan>
                </MenuItem>
                <MenuItem value="stpi">
                  <SelectSpan>
                    Software Technology Parks of India (STPI)
                  </SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>{errors.company_nature?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          {showAffirmativeAction && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.affirmative_action_category)}
              >
                <VendorCardLabel>Affirmative action category</VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  displayEmpty
                  defaultValue=""
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="affirmative_action_category"
                  label="Affirmative action category"
                  name="affirmative_action_category"
                  {...register("affirmative_action_category", {
                    required: false,
                  })}
                  error={Boolean(errors?.affirmative_action_category)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select category
                    </span>
                  </MenuItem>
                  <MenuItem value="open">
                    <SelectSpan>OPEN</SelectSpan>
                  </MenuItem>
                  <MenuItem value="obc">
                    <SelectSpan>OBC</SelectSpan>
                  </MenuItem>
                  <MenuItem value="sc">
                    <SelectSpan>SC/ST</SelectSpan>
                  </MenuItem>
                  <MenuItem value="other">
                    <SelectSpan>OTHERS</SelectSpan>
                  </MenuItem>
                  <MenuItem value="dnd">
                    <SelectSpan>Don't wish to declare</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {errors.affirmative_action_category?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
          {is_domestic && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.registration_type)}
              >
                <VendorCardLabel>
                  Registration type (GST) <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="registration_type"
                  label="Registration_type"
                  name="registration_type"
                  {...register("registration_type", {
                    required: "Please select registration type",
                  })}
                  error={Boolean(errors?.registration_type)}
                  onChange={(e) => handleregistrationChange(e)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select registration type
                    </span>
                  </MenuItem>
                  <MenuItem value="regular">
                    <SelectSpan>Regular</SelectSpan>
                  </MenuItem>
                  <MenuItem value="composition">
                    <SelectSpan>Composition</SelectSpan>
                  </MenuItem>
                  <MenuItem value="unregistered">
                    <SelectSpan>Not Applicable</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {errors.registration_type?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Tax Identification number (TIN)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Do not enter GSTIN here"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="tax_identification_number"
              {...register("tax_identification_number", { required: false })}
            />
          </Grid>
          {showWebsite && (
            <Grid item xs={12} sm={6} md={4}>
              <VendorCardLabel>Website</VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter website"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="website"
                {...register("website", { required: false })}
              />
            </Grid>
          )}
          {showYearOfEstablishment && (
            <Grid item xs={12} sm={6} md={4}>
              <VendorCardLabel>Year of Establishment</VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter year of establishment"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="year_of_establishment"
                {...register("year_of_establishment", {
                  required: false,
                  pattern: {
                    value: /^\d{4}$/,
                    message: "Year of establishment must be a 4-digit number",
                  },
                })}
                error={Boolean(errors?.year_of_establishment)}
                helperText={errors?.year_of_establishment?.message}
              />
            </Grid>
          )}
          {/* </Grid>
          <br />
          <Grid container spacing={3}> */}
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Million)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              style={{
                width: "100%",
                paddingTop: "3px",
                borderBottom: "1px solid lightgray",
              }}
              name="annual_turnover"
              placeholder="Enter annual turnover"
              {...register("annual_turnover", {
                pattern: {
                  value: /^-?\d*(\.\d{1,2})?$/,
                  message: "Invalid number format",
                },
              })}
              error={Boolean(errors?.annual_turnover)}
              helperText={errors.annual_turnover?.message}
              onChange={convertToMillions}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Crore)</VendorCardLabel>
            <VendorDisabledFields>{annualCr}</VendorDisabledFields>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const msme_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>MSME information</VendorCardTitle>
        <VRSubTitle>For tax purposes</VRSubTitle>
        <Grid container spacing={1}>
          {is_domestic && (
            <Grid item xs={12} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.msme_register)}
              >
                <VendorCardLabel>
                  Are you MSME registered? <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="Are you MSME registered?"
                  name="msme_register"
                  {...register("msme_register", {
                    required: "Please select MSME category",
                  })}
                  onChange={(e) => handlemsme(e.target.value)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select value
                    </span>
                  </MenuItem>
                  <MenuItem value="Applicable">
                    <SelectSpan>Applicable</SelectSpan>
                  </MenuItem>
                  <MenuItem value="others">
                    <SelectSpan>Not Applicable</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {errors.msme_registered?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          {mSME !== "others" && mSME !== "" ? (
            <>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    MSME registration number <Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: "1px solid lightgray",
                    }}
                    name="msme_registration_number"
                    placeholder="Enter MSME registration number"
                    {...register("msme_registration_number", {
                      required: false,
                    })}
                    value={msmenum || ""}
                    onChange={(e) => {
                      setMsmenum(e.target.value);
                      setCheckedMSME(false);
                    }}
                    error={Boolean(errors?.msme_registration_number)}
                    helperText={errors?.msme_registration_number?.message}
                  />
                </FormControl>
                {msmeLoading && (
                  <div style={{ marginTop: "5px" }}>
                    <span
                      style={{
                        fontSize: "13px",
                        color: "var(--button-color, #4945FF)",
                        fontStyle: "italic",
                      }}
                    >
                      Fetching details from Government portal...
                    </span>
                  </div>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <LoadingButton
                  variant="contained"
                  loading={msmeLoading}
                  startIcon={checkedMSME ? <CheckCircleIcon /> : null}
                  sx={{
                    width: "160px",
                    marginTop: "10px",
                    backgroundColor: checkedMSME ? "#4caf50" : undefined,
                    "&:hover": checkedMSME
                      ? { backgroundColor: "#388e3c" }
                      : undefined,
                    pointerEvents: checkedMSME ? "none" : "auto",
                  }}
                  onClick={validateMsme}
                  disabled={!msmenum}
                >
                  {checkedMSME ? "Validated" : "Validate MSME"}
                </LoadingButton>
              </Grid>

              {checkedMSME && validatedMsmeData && (
                <Grid item xs={12}>
                  <br />
                  <MsmeComponents
                    msme_type={validatedMsmeData.msme_type}
                    enterprise_name={validatedMsmeData.enterprise_name}
                    enterprise_activity={validatedMsmeData.enterprise_activity}
                    classification_date={validatedMsmeData.classification_date}
                    classification_year={validatedMsmeData.classification_year}
                  />
                  <br />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.msme)}
                >
                  <VendorCardLabel>
                    Upload MSME copy<Super>*</Super>
                  </VendorCardLabel>
                  {msmeDoc !== "" ? (
                    <>
                      <span
                        style={{
                          color: "#4945FF",
                          fontSize: "13px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={msmeDoc.name}
                          value={msmeDoc.name}
                          name="chips"
                        />
                        <HighlightOffIcon
                          sx={{
                            color: "#4945FF",
                            paddingBottom: "2px",
                            cursor: "pointer",
                          }}
                          fontSize="medium"
                          onClick={(e) => setmsmeDoc("")}
                        />
                      </span>
                    </>
                  ) : (
                    <label htmlFor="msme">
                      <Input
                        {...register("msme", {
                          required: "Please upload MSME copy",
                        })}
                        accept="*"
                        id="msme"
                        onChange={(e) => setmsmeDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {msmeDoc === "" ? (
                    <FormHelperText>{errors.msme?.message}</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
      </Container>
    </CardContent>
  );

  const registration_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Registration Information</VendorCardTitle>
        <VRSubTitle>For registration and verification purposes</VRSubTitle>
        <Grid container spacing={2}>
          {showCinValidation && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  CIN Number / Registration ID
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.cin_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a CIN Number / Registration ID? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={
                      isCinForced
                        ? "Applicable"
                        : watchedCinApplicable || "Not Applicable"
                    }
                    disabled={isCinForced}
                    onChange={(e) =>
                      setValue("cin_applicable", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="cin_applicable"
                    name="cin_applicable"
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.cin_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {resolvedCinApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      CIN Number / Registration ID <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter CIN / Registration ID"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="cin_number"
                      {...register("cin_number", {
                        pattern: {
                          value:
                            /^[LUlu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
                          message:
                            "Invalid CIN number (21-digit alphanumeric starting with L or U)",
                        },
                      })}
                      error={Boolean(errors?.cin_number)}
                      helperText={errors?.cin_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(cinError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload CIN copy <Super>*</Super>
                      </VendorCardLabel>
                      {cinDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={cinDoc.name}
                            value={cinDoc.name}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setCinDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="cin_doc_upload">
                          <Input
                            accept="*"
                            id="cin_doc_upload"
                            name="cin_doc_upload"
                            onChange={(e) => {
                              setCinDoc(e.target.files[0]);
                              setCinError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {cinError && <FormHelperText>{cinError}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showIecRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Import Export Code (IEC)
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.iec_applicable)}
                >
                  <VendorCardLabel>
                    Do you have an Import Export Code? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={watchedIecApplicable || ""}
                    onChange={(e) =>
                      setValue("iec_applicable", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="iec_applicable"
                    name="iec_applicable"
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.iec_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedIecApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Import Export Code <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Import Export Code"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="iec_number"
                      {...register("iec_number", {
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message:
                            "Invalid Import Export Code (10-digit number)",
                        },
                      })}
                      error={Boolean(errors?.iec_number)}
                      helperText={errors?.iec_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(iecError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Import Export Code <Super>*</Super>
                      </VendorCardLabel>
                      {iecDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={iecDoc.name}
                            value={iecDoc.name}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setIecDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="iec_doc_upload">
                          <Input
                            accept="*"
                            id="iec_doc_upload"
                            name="iec_doc_upload"
                            onChange={(e) => {
                              setIecDoc(e.target.files[0]);
                              setIecError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {iecError && <FormHelperText>{iecError}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showFactoryRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Factory License
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.factory_license_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a Factory License? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={watchedFactoryApplicable || ""}
                    onChange={(e) =>
                      setValue("factory_license_applicable", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="factory_license_applicable"
                    name="factory_license_applicable"
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.factory_license_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedFactoryApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Factory License Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Factory License Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="factory_license_number"
                      {...register("factory_license_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{3,30}$/,
                          message:
                            "Invalid Factory License number (3-30 alphanumeric characters)",
                        },
                      })}
                      error={Boolean(errors?.factory_license_number)}
                      helperText={errors?.factory_license_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(factoryError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Factory License <Super>*</Super>
                      </VendorCardLabel>
                      {factoryDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={factoryDoc.name}
                            value={factoryDoc.name}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setFactoryDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="factory_doc_upload">
                          <Input
                            accept="*"
                            id="factory_doc_upload"
                            name="factory_doc_upload"
                            onChange={(e) => {
                              setFactoryDoc(e.target.files[0]);
                              setFactoryError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {factoryError && (
                        <FormHelperText>{factoryError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showEprRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  EPR Certificate
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.epr_applicable)}
                >
                  <VendorCardLabel>
                    Do you have an EPR Number? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={watchedEprApplicable || ""}
                    onChange={(e) =>
                      setValue("epr_applicable", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="epr_applicable"
                    name="epr_applicable"
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.epr_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedEprApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      EPR Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter EPR Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="epr_number"
                      {...register("epr_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{5,50}$/,
                          message: "Invalid EPR number (5-50 characters)",
                        },
                      })}
                      error={Boolean(errors?.epr_number)}
                      helperText={errors?.epr_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(eprError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload EPR Certificate <Super>*</Super>
                      </VendorCardLabel>
                      {eprDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={eprDoc.name}
                            value={eprDoc.name}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setEprDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="epr_doc_upload">
                          <Input
                            accept="*"
                            id="epr_doc_upload"
                            name="epr_doc_upload"
                            onChange={(e) => {
                              setEprDoc(e.target.files[0]);
                              setEprError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {eprError && <FormHelperText>{eprError}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      EPR Certificate Expiry <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      type="date"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="epr_expiry"
                      {...register("epr_expiry")}
                      error={Boolean(errors?.epr_expiry)}
                      helperText={errors?.epr_expiry?.message}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showPollutionRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Pollution Control Certificate
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.pollution_control_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a Pollution Control Certificate?{" "}
                    <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={watchedPollutionApplicable || ""}
                    onChange={(e) =>
                      setValue("pollution_control_applicable", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="pollution_control_applicable"
                    name="pollution_control_applicable"
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.pollution_control_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedPollutionApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Pollution Control Certificate Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Pollution Control Certificate Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="pollution_control_number"
                      {...register("pollution_control_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{5,50}$/,
                          message:
                            "Invalid Pollution Control number (5-50 characters)",
                        },
                      })}
                      error={Boolean(errors?.pollution_control_number)}
                      helperText={errors?.pollution_control_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(pollutionError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Pollution Control Certificate <Super>*</Super>
                      </VendorCardLabel>
                      {pollutionDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={pollutionDoc.name}
                            value={pollutionDoc.name}
                          />
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setPollutionDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="pollution_doc_upload">
                          <Input
                            accept="*"
                            id="pollution_doc_upload"
                            name="pollution_doc_upload"
                            onChange={(e) => {
                              setPollutionDoc(e.target.files[0]);
                              setPollutionError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {pollutionError && (
                        <FormHelperText>{pollutionError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Pollution Control Expiry <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      type="date"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="pollution_control_expiry"
                      {...register("pollution_control_expiry")}
                      error={Boolean(errors?.pollution_control_expiry)}
                      helperText={errors?.pollution_control_expiry?.message}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Container>
    </CardContent>
  );

  /* const unused_documents = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "3px" }}>
          Documents
        </VendorCardTitle>
        <VRSubTitle>
          <span>
            <InfoIcon color="primary" />
          </span>
          {"\u00A0"}
          {"\u00A0"}
          TDS may be deducted at higher rates in case of incorrect or missing
          PAN information as per IT rules
        </VRSubTitle>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {is_domestic === true ? (
            <>
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels>
                    Upload PAN copy<Super>*</Super>
                  </DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.pan)}
                >
                  {panDoc !== "" ? (
                    <>
                      <span
                        style={{
                          color: "#4945FF",
                          fontSize: "13px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={panDoc.name}
                          value={panDoc.name}
                          name="chips"
                        />
                        <HighlightOffIcon
                          sx={{ color: "#4945FF", paddingBottom: "2px" }}
                          fontSize="medium"
                          onClick={(e) => setPanDoc("")}
                        />
                      </span>
                    </>
                  ) : (
                    <label htmlFor="pan">
                      <Input
                        {...register("pan", {
                          required: "Please upload PAN copy",
                        })}
                        accept="*"
                        id="pan"
                        onChange={(e) => setPanDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {panDoc === "" ? (
                    <FormHelperText>{errors.pan?.message}</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
        <br />

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                {isVendorTerms ? "VAD" : "Vendor information form"}
                {isVendorApproval ? (
                  <Super>*</Super>
                ) : (
                  ""
                )}
              </DocumentLabels>
              {isVendorApproval ? (
                <CustomDocumentLink
                  style={{ fontSize: "0.8rem" }}
                  href={VRF_vishakha}
                >
                  <FileDownload fontSize="small" color="primary" />
                  {"\u00A0"} Download Form
                </CustomDocumentLink>
              ) : (
                ""
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.dealerName)}
            >
              {dealer !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={dealer.name}
                      value={dealer.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDealer("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    {...register("dealerName", {
                      required: isVendorApproval
                        ? "Please upload vendor form copy"
                        : false,
                    })}
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDealer(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{dealer.name}</span>
                </label>
              )}
              {dealer === "" ? (
                <FormHelperText>{errors.dealerName?.message}</FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>



        <br />
        {isVendorApproval ? (
          ""
        ) : (
          <>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels> Upload TIN certificate</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {tin !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={tin.name}
                        value={tin.name}
                        name="chips"
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setTin("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="tin_doc">
                    <Input
                      accept="*"
                      id="tin_doc"
                      name="tin_doc"
                      onChange={(e) => setTin(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{tin.name}</span>
                  </label>
                )}
              </Grid>
            </Grid>
            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels>
                    Upload ISO, RSDO and any additional certificate
                  </DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {iso !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={iso.name}
                        value={iso.name}
                        name="chips"
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setIso("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="iso_doc">
                    <Input
                      accept="*"
                      id="iso_doc"
                      name="iso_doc"
                      onChange={(e) => setIso(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{iso.name}</span>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload COA / Test Certificate</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {coa !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={coa.name}
                        value={coa.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setCoa("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="coa_doc">
                    <Input
                      accept="*"
                      id="coa_doc"
                      name="coa_doc"
                      onChange={(e) => setCoa(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Quality Audit Report</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {qualityAudit !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={qualityAudit.name}
                        value={qualityAudit.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setQualityAudit("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="quality_audit_doc">
                    <Input
                      accept="*"
                      id="quality_audit_doc"
                      name="quality_audit_doc"
                      onChange={(e) => setQualityAudit(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Hazardous Material Declaration</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {hazardous !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={hazardous.name}
                        value={hazardous.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setHazardous("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="hazardous_doc">
                    <Input
                      accept="*"
                      id="hazardous_doc"
                      name="hazardous_doc"
                      onChange={(e) => setHazardous(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload SDS / MSDS Availability</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {sds !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={sds.name}
                        value={sds.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setSds("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="sds_doc">
                    <Input
                      accept="*"
                      id="sds_doc"
                      name="sds_doc"
                      onChange={(e) => setSds(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload UN Certificates</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {unCert !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={unCert.name}
                        value={unCert.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setUnCert("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="un_cert_doc">
                    <Input
                      accept="*"
                      id="un_cert_doc"
                      name="un_cert_doc"
                      onChange={(e) => setUnCert(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Vendor Site Images</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {vendorSite !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={vendorSite.name}
                        value={vendorSite.name}
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px", cursor: "pointer" }}
                        fontSize="medium"
                        onClick={(e) => setVendorSite("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="vendor_site_doc">
                    <Input
                      accept="*"
                      id="vendor_site_doc"
                      name="vendor_site_doc"
                      onChange={(e) => setVendorSite(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>
          </>
        )}

        {newDocs.map((item, index) => (
          <>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              key={index}
            >
              <>
                <Grid item xs={6}>
                  <span
                    variant="outlined"
                    component="span"
                    style={{ width: "50%" }}
                  >
                    <DocumentLabels style={{ marginTop: "10px" }}>
                      Upload Any Documents
                    </DocumentLabels>
                  </span>
                </Grid>
                {anyDocs[index] !== "" && anyDocs[index] !== undefined ? (
                  <>
                    <Grid item xs={6}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={anyDocs[index].name}
                            value={anyDocs[index].name}
                            name="chips"
                          />
                          <HighlightOffIcon
                            sx={{ color: "#4945FF", paddingBottom: "2px" }}
                            fontSize="medium"
                            onClick={(e) => handleclearDoc(e, index)}
                          />
                        </span>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      {index === 0 ? (
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleOnClick}
                          className="invoiceErrbutn"
                        >
                          Add Document
                        </CustomButton>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={3}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <label>
                          <Input
                            accept="*"
                            id={`anyDocs${index}`}
                            onChange={(e) => handlechangeDoc(e, index)}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      {index === 0 ? (
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleOnClick}
                          className="invoiceErrbutn"
                          style={{ marginTop: "10px " }}
                        >
                          Add Document
                        </CustomButton>
                      ) : (
                        <CustomButton
                          className="invoiceErrbutn"
                          color="error"
                          variant="outlined"
                          size="small"
                          onClick={(e) => handleRemove(e, index)}
                          style={{ marginTop: "10px " }}
                        >
                          Remove
                        </CustomButton>
                      )}
                    </Grid>
                  </>
                )}
              </>
            </Grid>
          </>
        ))}
      </Container>
    </CardContent>
  ); */

  const major_customer_list_ui = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "10px" }}>
          Major Customer List
        </VendorCardTitle>
        <VRSubTitle style={{ marginBottom: "15px" }}>
          Provide the names of your major customers
        </VRSubTitle>
        <Grid container spacing={2}>
          {majorCustomers.map((customer, index) => (
            <Grid
              container
              item
              spacing={1}
              alignItems="center"
              key={index}
              xs={12}
            >
              <Grid item xs={10} sm={6} md={4}>
                <VendorCardLabel>Customer Name {index + 1}</VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{ disableUnderline: false }}
                  placeholder="Enter Customer Name"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  value={customer}
                  onChange={(e) => handleCustomerChange(index, e.target.value)}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1} style={{ marginTop: "15px" }}>
                <HighlightOffIcon
                  sx={{ color: "#d32f2f", cursor: "pointer" }}
                  onClick={() => handleRemoveCustomer(index)}
                />
              </Grid>
            </Grid>
          ))}
          <Grid item xs={12} style={{ marginTop: "15px" }}>
            <CustomButton
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleAddCustomer}
              className="invoiceErrbutn"
            >
              + Add more
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const additional_info = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Additional information</VendorCardTitle>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={6} md={9}>
            <VRSubTitle>
              Areas of business interest. Select all that apply and wait for the
              HSN/SAC code to appear below
            </VRSubTitle>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <VRSubTitle style={{ textAlign: "right" }}>
              <a
                rel="noopener noreferrer"
                href={`${vendorCompany?.domain_url}/api/hsn_codes`}
                style={{
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  color: "#4059e5",
                }}
                target="_blank"
              >
                Download Codesheet
              </a>
            </VRSubTitle>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item md={3} xs={12}>
            <AdditionalDetailsCard>
              <CardContent style={{ overflow: "auto", height: "272px" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  // style={{ marginTop: "36px" }}
                >
                  <Grid
                    style={checkedType === "2" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="2"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Goods"
                      style={{
                        textAlign: "-23px",
                      }}
                      onChange={(e) => handleadditionalChange(e, "2")}
                      className="goods"
                    />

                    {checkedType === "2" ? (
                      <ArrowRightIcon
                        style={{
                          textAlign: "center",
                          float: "right",
                          marginTop: "7px",
                          marginLeft: "-32px",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    style={checkedType === "1" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="1"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Services"
                      /*  style={{ textAlign: "-25px" }} */
                      onChange={(e) => handleadditionalChange(e, "1")}
                      className="goods"
                    />
                    <span
                      style={{
                        textAlign: "center",
                        float: "right",
                        marginTop: "7px",
                        marginLeft: "-32px",
                      }}
                    >
                      {checkedType === "1" ? <ArrowRightIcon /> : ""}
                    </span>
                  </Grid>

                  {isLinkCategory ? (
                    <Grid
                      style={
                        checkedType === "3" ? radioStyles.selectRadio : null
                      }
                    >
                      <CustomFormSelection
                        value="3"
                        control={<Radio style={{ visibility: "hidden" }} />}
                        label="Item"
                        /*  style={{ textAlign: "-25px" }} */
                        onChange={(e) => handleadditionalChange(e, "3")}
                        className="goods"
                      />
                      <span
                        style={{
                          textAlign: "center",
                          float: "right",
                          marginTop: "7px",
                          marginLeft: "-32px",
                        }}
                      >
                        {checkedType === "3" ? <ArrowRightIcon /> : ""}
                      </span>
                    </Grid>
                  ) : (
                    ""
                  )}
                </RadioGroup>
              </CardContent>
            </AdditionalDetailsCard>
          </Grid>
          {isLoading ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : code_filtered ? (
            <Grid item md={3} xs={12} style={{ display: catdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => handleSearchChange(e)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by description"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {code_filtered.length ? (
                      code_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            subCategory === `${item.category}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.categortDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={item.categortDescription}
                              value={item.category}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlecategoryChange(e, `${item.category}`)
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingsub ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : sub_filtered ? (
            <Grid item md={3} xs={12} style={{ display: subcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchsub(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {sub_filtered.length ? (
                      sub_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            itemcodes === `${item.subCategory}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.subCategoryDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={
                                item.subCategory +
                                " - " +
                                item.subCategoryDescription
                              }
                              value={item.subCategory}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlesubcategoryChange(
                                  e,
                                  `${item.subCategory}`,
                                )
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingitem ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : item_filtered ? (
            <Grid item md={3} xs={12} style={{ display: itemcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchitem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {item_filtered.length ? (
                    item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item.itemDescription}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item.item}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(`${item.item}`)}
                                />
                              }
                              label={item.item + " - " + item.itemDescription}
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item.item}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
          {isLoadingMasteritem ? (
            <Grid item md={9} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : master_item_filtered ? (
            <Grid item md={9} xs={12} style={{ display: mastercatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchMasteritem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {master_item_filtered.length ? (
                    master_item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item?.MaterialCode}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item["MaterialCode"]}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(
                                    `${item.MaterialCode}`,
                                  )}
                                />
                              }
                              label={
                                item["MaterialCode"] +
                                " - " +
                                item["Description"]
                              }
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item["MaterialCode"]}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <br />
        <VendorCardTitle style={{ paddingBottom: "0px" }}>
          Selected HSN/SAC Codes
        </VendorCardTitle>
        <FormControl>
          <Stack direction="row" spacing={4}>
            <Grid item xs={2}>
              <VendorCardBlankTitle
                style={{ marginTop: "0", marginBottom: "10px" }}
              >
                {userinfo.codes.length ? "" : "No codes selected."}
              </VendorCardBlankTitle>

              {userinfo.codes.map((item, index) =>
                item !== "null" ? (
                  <Chip
                    key={index}
                    style={{
                      color: "#4945FF",
                      margin: "0 5px 10px 0 ",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={item}
                    value={item}
                    name="chips"
                    onDelete={handleDelete(item)}
                    deleteIcon={
                      <Clear sx={{ height: "18px", width: "18px" }} />
                    }
                  />
                ) : (
                  ""
                ),
              )}
            </Grid>
          </Stack>
        </FormControl>
        <Grid>
          <VendorCardLabel>Additional business areas</VendorCardLabel>
          <TextField
            sx={{
              input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" },
            }}
            id="standard-basic"
            placeholder="Enter interest areas"
            variant="standard"
            style={{ width: "100%" }}
            name="business_interest_areas"
            {...register("business_interest_areas", {
              required: false,
            })}
          />
        </Grid>
        <br />
        {is_domestic === true ? (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={handleChange}
                name="pan_declaration"
              />
            }
            label={
              <CheckBoxLabel>
                I confirm that the PAN I entered above should be used for all
                TDS deductions made for our company payments
              </CheckBoxLabel>
            }
          />
        ) : (
          ""
        )}
        {isVendorTerms && (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={(e) => {
                  if (e.currentTarget.checked) {
                    set_is_accept_vendor_terms_conditions(true);
                  } else {
                    set_is_accept_vendor_terms_conditions(false);
                  }
                }}
                name="is_accept_vendor_terms_conditions"
              />
            }
            label={
              <CheckBoxLabel>
                I have read & agreed to&nbsp;
                <a
                  href={vendorTermsAndConditions?.terms_and_condtions_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{` Terms & Conditions`}</span>
                </a>
              </CheckBoxLabel>
            }
          />
        )}
      </Container>
    </CardContent>
  );

  useEffect(() => {
    if (isVendorTerms) {
      dispatch(getVendorTermsAndConditions());
    }
    // eslint-disable-next-line
  }, []);
  if (!value) return null;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          <div className="stepsDiv">
            {steps.map((label, index) => {
              const stepProps = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              const isCompleted = index < activeStep;
              const isCurrent = index === activeStep;
              return (
                <>
                  <div
                    key={index}
                    className={
                      isCompleted
                        ? "stepcolm fstone_1"
                        : isCurrent
                          ? index === 0
                            ? "stepcolm fstone"
                            : "stepcolm secone_1"
                          : "stepcolm secone"
                    }
                  >
                    <div key={index}>
                      {isCompleted ? (
                        <span>
                          <CheckCircleIcon className="checkedCircle" />
                        </span>
                      ) : (
                        <span>{`${index + 1}. `}</span>
                      )}
                      {label}
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            <br />
            {activeStep === 0 ? (
              <>
                <form
                  onSubmit={handleSubmit(handleNext)}
                  encType="multipart/form-data"
                >
                  <StyledCard>{card}</StyledCard>

                  <StyledCard>{statutory_information}</StyledCard>

                  {is_domestic && <StyledCard>{msme_information}</StyledCard>}

                  {showRegInfoCard && (
                    <StyledCard>{registration_information}</StyledCard>
                  )}

                  {/* <StyledCard>{documents}</StyledCard> */}

                  {showMajorCustomerList && (
                    <StyledCard>{major_customer_list_ui}</StyledCard>
                  )}

                  <StyledCard>{additional_info}</StyledCard>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1, display: "none" }}
                    >
                      Back
                    </Button>

                    <Box sx={{ flex: "1 1 auto" }} />
                    <LoadingButton
                      sx={{
                        textTransform: "none",
                        background: "var(--button-color)",
                        width: "200px",
                        height: "40px",
                      }}
                      color="success"
                      variant="contained"
                      disabled={
                        is_domestic !== true
                          ? false
                          : !checkedPan ||
                              (isVendorTerms &&
                                !is_accept_vendor_terms_conditions)
                            ? true
                            : false
                      }
                      type="submit"
                      loading={loading}
                      loadingPosition="start"
                    >
                      {activeStep === steps.length - 1
                        ? isVendorApproval || isVendorTerms
                          ? "Save & Next"
                          : "Finish"
                        : "Save & Next"}
                    </LoadingButton>
                  </Box>
                </form>
              </>
            ) : activeStep === 1 ? (
              <>
                <BankReg
                  activeStep={activeStep}
                  handleBack={handleBack}
                  checkedPan={checkedPan}
                  steps={steps}
                  registrationtype={registrationtype}
                  clientId={vendorCompany?.id}
                  is_domestic={is_domestic}
                  setActiveStep={setActiveStep}
                  setSkipped={setSkipped}
                  isStepSkipped={isStepSkipped}
                  skipped={skipped}
                />
              </>
            ) : activeStep === 2 ? (
              <BankDetailsManager
                activeStep={activeStep}
                handleBack={handleBack}
                user_id={value?.id || createdUser?.id}
                vendor_id={value?.vendor_id || createdUser?.vendor_id}
                is_domestic={is_domestic}
                company_id={vendorCompany?.id}
                setSkipped={setSkipped}
                setActiveStep={setActiveStep}
                isStepSkipped={isStepSkipped}
                skipped={skipped}
                isLocked={false}
                isCreation={true}
              />
            ) : activeStep === 3 ? (
              <VendorDocumentRequests
                isStepper={true}
                handleBack={handleBack}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                isLocked={false}
                isCreation={true}
                vendor_id={
                  value?.vendor_id || createdUser?.vendor_id || value?.id
                }
                skipped={skipped}
                setSkipped={setSkipped}
                isStepSkipped={isStepSkipped}
              />
            ) : (
              <>
                <StyledCard>
                  <CardContent>
                    <VendorCardTitle>Finish Registration</VendorCardTitle>
                    <Typography
                      sx={{
                        my: 2,
                        color: "#4A4A6A",
                        fontSize: "15px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      You have successfully filled in all the registration
                      details. Please click the "Finish" button below to submit
                      your details.
                    </Typography>
                  </CardContent>
                </StyledCard>

                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>
                    Back
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <LoadingButton
                    sx={{
                      textTransform: "none",
                      background: "var(--button-color)",
                      width: "200px",
                      height: "40px",
                    }}
                    color="success"
                    variant="contained"
                    onClick={handleFinalSubmit}
                    loading={finalSubmitLoading}
                  >
                    Finish
                  </LoadingButton>
                </Box>
              </>
            )}
          </React.Fragment>
        )}
      </Box>
    </>
  );
}

export const StyledCard = materialStyles(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorDisabledFields = styled.div`
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #212134;
`;

export const VendorLabelHolder = styled.div`
  text-align: left;
`;

export const StyledOutlineButton = materialStyles(Button)`
  border: 1px solid var(--button-color);
  color: black;
  height: 40px;
  padding: 8px 30px;
`;

export const StyledFilledButton = materialStyles(Button)`
  background: #1CB697;
  color: #fff;
  height: 40px;
  padding: 8px 30px;
`;

export const AdditionalDetailsCard = materialStyles(Card)`
border: 1px solid #D9D8FF;
background: #F7F9FC;
box-shadow: none;
`;

export const VRSubTitle = styled.div`
  margin-top: -15px;
  margin-bottom: 20px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/600 */

  color: #666687;
`;

export const DocumentLabels = styled.div`
  //styleName: 14/Medium;
  font-family: var(--font-family-med);
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
`;

export const CheckBoxLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Neutral/900 */

  color: #212134;
`;

export const StyledStep = materialStyles(Step)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const CustomButton = materialStyles(Button)`
 ::hover{
   background-color: #1cb;
   font-size: 16.5px;
   transition: all 0.3ms ease-in;
 }
`;

export const SelectSpan = styled.span`
  font-family: var(--font-family-reg);
  font-size: 14px;
  color: "black";
`;

export const StepsSpan = styled.span`
  font-family: var(--font-family-reg);
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  padding-right: 10px;
  color: #4a4a6a;
`;

export const CustomFormControl = materialStyles(FormControlLabel)`
.css-ahj2mt-MuiTypography-root {
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;


}
`;

export const CustomFormSelection = materialStyles(FormControlLabel)`
.css-ahj2mt-MuiTypography-root {
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
`;
